/* Tippy stylesheet and specific styles are imported in the global tooltip.scss file */

:host {
    display: none;
}
